import { Controller } from "@hotwired/stimulus"

// Drives a <dialog> loaded into the #modal turbo-frame: opens it on connect,
// closes on backdrop click, and empties the frame once closed so it can be
// reused.
export default class extends Controller {
  connect() {
    if (this.element.tagName === "DIALOG" && !this.element.open) {
      this.element.showModal()
    }
  }

  close() {
    this.element.close()
  }

  // A click whose target is the dialog itself landed on the ::backdrop.
  backdropClose(event) {
    if (event.target === this.element) this.element.close()
  }

  cleanup() {
    const frame = this.element.closest("turbo-frame")
    if (frame) frame.innerHTML = ""
  }
}
